module.exports = __webpack_public_path__ + "img/group_box1_icon.4d3cd8cf.png";